// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/ContentWrapper.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/ContentWrapper.tsx");
  import.meta.hot.lastModified = "1773386006986.6948";
}
// REMIX HMR END

import clsx from "clsx";
const variant = {
  primary: "children:max-w-page px-4 py-10 md:px-24 md:py-14",
  secondary: "children:max-w-article px-4 py-4 md:px-24",
  tertiary: "children:max-w-8xl pb-14",
  quaternary: "children:max-w-8xl pb-8"
};
export default function ContentWrapper({
  Item = "div",
  className,
  spacing,
  children
}) {
  return <Item className={clsx("flex justify-center", variant[spacing], className)}>
      {children}
    </Item>;
}
_c = ContentWrapper;
var _c;
$RefreshReg$(_c, "ContentWrapper");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;